import { createContext, useContext } from "react";

import { Area } from "@/api/areas/types";

export type AreaContextType = {
  area: Area;
};

export const AreaContext = createContext<AreaContextType | null>(null);

export const useAreaContext = () => {
  const ctx = useContext(AreaContext);
  if (!ctx) throw new Error("useAreaContext must be used within AreaContext");
  return ctx;
};
